function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/spinner.ts
import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { cssVar } from "@chakra-ui/theme-tools";
var $size = cssVar("spinner-size");
var baseStyle = defineStyle({
  width: [$size.reference],
  height: [$size.reference]
});
var sizes = {
  xs: defineStyle(_defineProperty({}, $size.variable, "sizes.3")),
  sm: defineStyle(_defineProperty({}, $size.variable, "sizes.4")),
  md: defineStyle(_defineProperty({}, $size.variable, "sizes.6")),
  lg: defineStyle(_defineProperty({}, $size.variable, "sizes.8")),
  xl: defineStyle(_defineProperty({}, $size.variable, "sizes.12"))
};
var spinnerTheme = defineStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md"
  }
});
export { spinnerTheme };